/**
 * * Catalogus: Werkregel: Attachments
 */
import React from "react";
import $, { Callbacks } from "jquery";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { Slide } from "react-slideshow-image";

class Attachments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      media: [],
      formDataPost: null,
      file: null,
      gettingMedia: null,
      imagesUrl: null,
      clickFileName: null,
      txtUrls: [],
      shortName: null,
      // kabul edilen media tipleri
      acceptFileType: [
        "text/plain",
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
      ],
      dowloadAcceptFileType: [
        "text/plain",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
      ],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteMedia = this.deleteMedia.bind(this);
    this.getMedia = this.getMedia.bind(this);
  }

  /**
   * * props değişimleri burada yakalanıyor
   */
  handleEvent() {
    var test = "";
    this.state = {
      media:
        this.props.media == null
          ? []
          : this.props.media != null &&
            this.state.media.data &&
            this.state.media.data.files.length > 0 &&
            this.props.media.data.files.length !==
              this.state.media.data.files.length
          ? this.state.media
          : this.props.media,
      formDataPost: this.state.formDataPost,
      file: this.state.file,
      gettingMedia: this.state.gettingMedia,
      imagesUrl: this.state.imagesUrl,
      clickFileName: this.state.clickFileName,
      txtUrls: this.state.txtUrls,
      acceptFileType: this.state.acceptFileType,
      dowloadAcceptFileType: this.state.dowloadAcceptFileType,
      shortName: this.state.shortName,
    };
  }

  /**
   * * yüklenecek dosya vazgeçildinde çalışan fonksiyon
   */
  fileUnSelect() {
    this.setState({ formDataPost: null, file: null });
  }

  /**
   * * dosya seçildiğinde çalışan fonksiyon
   *
   * @param {event}
   * e parametresi biz source'dan seçilen file bilgilerine ulaşmamızı sağlar
   */
  fileOnChange = (e) => {
    let file = e.target.files[0];
    if (this.state.acceptFileType.includes(file.type)) {
      const formData = new FormData();
      formData.append("content", file);
      formData.append(
        "metadata",
        `{"filename":"${file.name}","description":"","mime_type":"${file.type}","definition_code":"TEST"}`
      );

      this.setState({ formDataPost: formData, file: file });
    } else alert("invalid media type");
  };

  /**
   * * dosya karşı tarafa yüklenmesini sağlar
   */
  async handleSubmit() {
    $("#cover-spin").show(0);

    var that = this;
    await omnimap
      .PostMediaAction(
        that.state.formDataPost,
        window.$catalog_work_plans_selectedRow.identification,
        window.$catalog_management_units_token
      )
      .then(async (result) => {
        let getResult = await omnimap.GetMediaListAction(
          { path: "" },
          window.$catalog_work_plans_selectedRow.identification,
          window.$catalog_management_units_token
        );
        await this.setState({
          media: getResult,
          formDataPost: null,
          file: null,
        });
        await $("#cover-spin").hide(0);

        CommonFunctions.UpdateAttachmentCount(getResult.data.files.length);
      });
  }

  /**
   * * media silmek için kullanılır
   *
   * @param {string} rowId
   * listelenen media verilerinin seçilmiş olan ids'si
   */
  async deleteMedia(rowId) {
    $("#cover-spin").show(0);

    var that = this;
    await omnimap
      .DeleteMediaAction(rowId, window.$catalog_management_units_token)
      .then(async (result) => {
        if (result.result.status == "OK") {
          let getResult = await omnimap.GetMediaListAction(
            { path: "" },
            window.$catalog_work_plans_selectedRow.identification,
            window.$catalog_management_units_token
          );
          await this.setState({
            media: getResult,
            formDataPost: null,
            file: null,
          });
          CommonFunctions.UpdateAttachmentCount(getResult.data.files.length);
        } else alert("error");

        $("#cover-spin").hide(0);
      });
  }

  /**
   * * media getirmek için kullanılır
   *
   * @param {string} rowId
   * listelenen media verilerinin seçilmiş olan ids'si
   */
  async getMedia(rowId) {
    $("#cover-spin").show(0);
    window.$catalog_work_plans_silederimages = [];
    let stateMedia = this.state.media;
    let count = 2;
    let totalCount = this.state.media.data.files.length;
    let clickFileName;

    let oneFile;
    let totalImageCount = this.state.media.data.files.filter((x) =>
      x.metadata.mime_type.includes("image")
    ).length;
    for (let i = 0; i < stateMedia.data.files.length; i++) {
      const e = stateMedia.data.files[i];

      if (e.metadata.identification !== rowId) {
        await CommonFunctions.GetMedia(e.metadata.identification).then(
          (result) => {
            if (String(e.metadata.mime_type).includes("image")) {
              let model = {
                order: count,
                name: `Bijlage ${count} van ${totalImageCount}`,
                url: result,
                filename: e.metadata.filename,
              };
              count++;
              window.$catalog_work_plans_silederimages.push(model);
            }
          }
        );
      } else {
        clickFileName = e.metadata.filename;
        oneFile = e.metadata;
      }
    }

    await CommonFunctions.GetMedia(rowId).then(async (result) => {
      if (this.state.dowloadAcceptFileType.includes(oneFile.mime_type)) {
        const url = result;
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // the filename you want
        a.download = clickFileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        let model = {
          order: 1,
          name: `Bijlage 1 van ${totalImageCount}`,
          url: result,
          filename: clickFileName,
        };
        count++;
        window.$catalog_work_plans_silederimages.push(model);

        await this.setState({
          imagesUrl: window.$catalog_work_plans_silederimages.sort(function (
            a,
            b
          ) {
            if (a.order < b.order) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            return 0;
          }),
          clickFileName: clickFileName,
          shortName: model.name,
        });

        await $("#wp-catalogus-attachments-images").modal("show");
      }
    });

    $("#cover-spin").hide(0);
  }

  imageModalClose() {
    this.setState({ imagesUrl: null });
  }

  /**
   * * başka bir kayıtın mediası istendiği zaman bu fonksiyon çalışır
   * @param {*} _media
   */
  mediaChange(_media) {
    this.setState({ media: _media });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.rowId && prevProps.rowId != this.props.rowId) {
      this.mediaChange(this.props.media);
    }
  }

  async sliderChange(oldIndex, newIndex) {
    await this.setState({
      shortName: window.$catalog_work_plans_silederimages[newIndex].name,
    });
    console.log(`slide transition from ${oldIndex} to ${newIndex}`);
  }

  async componentDidMount() {}

  render() {
    this.handleEvent();
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="wp-catalogus-attachments"
          data-backdrop="static"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Bijlage(n)</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="media-list">
                  <div class="upload-content">
                    <span class="upload-ico"></span>
                    <input
                      type="file"
                      id="upload"
                      hidden
                      onChange={this.fileOnChange}
                      accept={".jpg,.jpeg,.png,.pdf,.docx,.xlsx,.txt"}
                    />
                    <label for="upload">
                      {this.state.file !== null
                        ? `Bestand met de naam ${this.state.file.name} is geselecteerd`
                        : "Voeg bestand toe…"}{" "}
                    </label>
                    {this.state.file !== null ? (
                      <span
                        class="close-ico"
                        onClick={this.fileUnSelect.bind(this)}
                      ></span>
                    ) : (
                      ""
                    )}
                  </div>

                  {this.state.media.data !== undefined
                    ? this.state.media.data.files.map((m) => (
                        <div className="upload-content">
                          <span className="upload-ico"></span>
                          <a
                            role="button"
                            onClick={
                              () => this.getMedia(m.metadata.identification)
                              // String(m.metadata.mime_type).includes("image")
                              //   ? this.getMedia(m.metadata.identification)
                              //   : ""
                            }
                          >
                            {m.metadata.filename}
                          </a>
                          <span
                            className="delete-ico"
                            onClick={() =>
                              this.deleteMedia(m.metadata.identification)
                            }
                          ></span>
                        </div>
                      ))
                    : ""}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-modal-uploaden"
                  onClick={this.handleSubmit}
                  style={{
                    opacity: this.state.formDataPost !== null ? "1" : "0.4",
                    cursor:
                      this.state.formDataPost !== null ? "pointer" : "default",
                  }}
                >
                  Uploaden
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <AttachmentsImage images={this.state.imagesUrl} active={true} /> */}
        <div
          className="modal modal-child "
          tabIndex={-1}
          role="dialog"
          id="wp-catalogus-attachments-images"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content image">
              <div className="modal-header">
                <h5 className="modal-title">{"\u00A0"}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.imageModalClose.bind(this)}
                />
              </div>

              <div className="modal-body">
                <div className="modal-image">
                  {this.state.imagesUrl !== null ? (
                    <Slide
                      onChange={this.sliderChange.bind(this)}
                      duration={500000}
                      autoplay={false}
                      easing="ease"
                    >
                      {this.state.imagesUrl !== null
                        ? this.state.imagesUrl.map((m) => (
                            <div className="each-slide">
                              <h5 className="modal-title">{m.filename}</h5>
                              <div>
                                <img
                                  style={{ width: "100%", height: "100%" }}
                                  className="modal-image"
                                  src={m.url}
                                ></img>
                              </div>
                              {/* <span style={{ marginLeft: "345px" }}>
                                {m.name}
                              </span> */}
                            </div>
                          ))
                        : [1].map((m) => <div></div>)}
                    </Slide>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <label style={{ margin: "0 auto" }}>
                  {this.state.shortName}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachments;
